"use client";

import { ChartBar, Tags, Settings, Users, Search } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Settings,
  title: "Ad Operations & Campaign Management",
  description: ["Precise campaign implementation across platforms", "QA, troubleshooting, and performance monitoring", "Reliable execution that meets advertiser expectations"]
}, {
  id: 2,
  icon: Users,
  title: "Advertiser Success & Relationship Support",
  description: ["Clear communication and timely updates", "Proactive issue resolution before it impacts performance", "A better advertiser experience that strengthens relationships"]
}, {
  id: 3,
  icon: ChartBar,
  title: "Analytics, Reporting & Insights",
  description: ["Performance analysis that translates into action", "Insightful reporting for publishers and advertisers", "Recommendations that drive revenue and growth"]
}, {
  id: 4,
  icon: Tags,
  title: "Marketing Tagging, Conversion Tracking & CMP Compliance",
  description: ["Tag setup and validation for accurate measurement", "Ensuring tags fire properly within consent management platforms", "Privacy‑compliant tracking without sacrificing data quality", "Troubleshooting tracking discrepancies and data loss"]
}, {
  id: 5,
  icon: Search,
  title: "Technical Audits & Optimization",
  description: ["Comprehensive audits of marketing tags and tracking implementations", "Identification of missing, duplicate, or incorrectly firing tags", "Data layer validation and quality assurance across platforms", "Troubleshooting tracking discrepancies and data loss", "Prioritized recommendations to improve data accuracy, reliability, and compliance"]
}];
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref5,
    isVisible: isVisible5
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const refs = [ref1, ref2, ref3, ref4, ref5];
  const visibility = [isVisible1, isVisible2, isVisible3, isVisible4, isVisible5];
  return <section className="bg-background py-20 px-6 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-4xl font-bold text-foreground mb-12 text-center">
          Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          const isVis = visibility[i];
          const isDescriptionArray = Array.isArray(service.description);
          return <div key={service.id} data-index={i} ref={refs[i] as any} className="flex flex-col gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" style={{
            opacity: isVis ? 1 : 0,
            transform: isVis ? "translateY(0)" : "translateY(20px)",
            transitionDelay: `${i * 100}ms`
          }}>
                <div className="flex items-center justify-center w-16 h-16 rounded-lg bg-primary/10 text-primary-dark">
                  <IconComponent className="size-8" />
                </div>
                <h3 className="font-display text-xl font-semibold text-foreground">
                  {service.title}
                </h3>
                {isDescriptionArray ? <ul className="text-muted text-sm leading-relaxed list-disc ml-4 space-y-1">
                    {service.description.map((item, idx) => <li key={idx}>{item}</li>)}
                  </ul> : <p className="text-muted text-sm leading-relaxed">
                    {service.description}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}